<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms" [formGroup]="preOrderForm">
  <div class="accordion-class">
    <h5>{{ title }}</h5>
    <mat-divider></mat-divider>
    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="col-sm-5">
          <span>Truck Number :</span>
        </div>
        <div class="col-sm-7" *ngIf="data.data !== 'edit'">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input
              type="text"
              placeholder="Select Truck No"
              matInput
              [formControl]="truckControl"
              [matAutocomplete]="auto"
              required
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onOptionSelected($event)"
            >
              <mat-option
                *ngFor="let option of filteredOptions | async"
                [value]="option.truck_number"
              >
                {{ option.truck_number }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="truckControl.hasError('required')"
              >Truck Number is required</mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-sm-7" *ngIf="data.data !== 'add'">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input
              matInput
              formControlName="truck_number"
              placeholder="Truck Number"
              required
              readonly
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="col-sm-5">
          <span>Truck Category :</span>
        </div>
        <div class="col-sm-7">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input
              matInput
              formControlName="truck_category"
              placeholder="Truck Category"
              required
              readonly
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="col-sm-5">
          <span>Truck Type :</span>
        </div>
        <div class="col-sm-7">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input
              matInput
              formControlName="truck_type"
              placeholder="Truck Type"
              required
              readonly
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="col-sm-5">
          <span> Driver Number :</span>
        </div>
        <div class="col-sm-7">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input
              matInput
              formControlName="driver_number"
              placeholder="Driver Number"
              required
              readonly
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="col-sm-5">
          <span> Price/MT :</span>
        </div>
        <div class="col-sm-7">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input
              matInput
              formControlName="price"
              [readonly]="!!data.price"
            />
            <mat-error *ngIf="price?.hasError('twoDecimalPlaces')">
              Please enter a valid price with up to 2 decimal places.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 d-flex align-items-center justify-content-center">
        <button
          type="button"
          class="button buttonCancel my-3"
          [ngClass]="{ 'button-disabled': !preOrderForm.valid || isLoading }"
          *ngIf="data.data === 'add'"
          [disabled]="!preOrderForm.valid || isLoading"
          (click)="addTruck()"
        >
          <ng-container *ngIf="!isLoading">SUBMIT BID</ng-container>
          <ng-container *ngIf="isLoading">
            <span class="loader"></span>
            <!-- Loader animation -->
          </ng-container>
        </button>
        <button
          type="button"
          class="button buttonCancel my-3"
          [ngClass]="{ 'button-disabled': !preOrderForm.valid || isLoading }"
          *ngIf="data.data == 'edit'"
          [disabled]="!preOrderForm.valid || isLoading"
          (click)="updateTruck()"
        >
          <ng-container *ngIf="!isLoading">RESUBMIT BID</ng-container>
          <ng-container *ngIf="isLoading">
            <span class="loader"></span>
            <!-- Loader animation -->
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</form>
